import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Avatar,
  Box,
  Alert
} from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import LoadingScreen from './LoadingScreen';


const Leaderboard = () => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        setLoading(true);
        // Fetch countries from Firestore
        const countriesSnapshot = await getDocs(collection(db, 'countries'));
        const countriesData = countriesSnapshot.docs.map(doc => ({
          id: doc.id,
          name: doc.data().name
        }));

        // Fetch leaderboard ranks from Firestore
        const rankSnapshot = await getDocs(collection(db, 'leaderboard_main'));
        const rankData = rankSnapshot.docs.map(doc => doc.data());

        // Aggregate medal counts by country
        const countryMedals = {};
        countriesData.forEach(country => {
          countryMedals[country.name] = { gold: 0, silver: 0, bronze: 0 };
        });

        console.log(rankData);

        rankData.forEach(rank => {
          const { country, rank: rankValue } = rank;
          if (countryMedals[country]) {
            if (rankValue === '1') {
              countryMedals[country].gold += 1;
            } else if (rankValue === '2') {
              countryMedals[country].silver += 1;
            } else if (rankValue === '3') {
              countryMedals[country].bronze += 1;
            }
          }
        });

        // Convert to leaderboard data with total medals
        // Convert to leaderboard data with total medals
        const leaderboardData = Object.entries(countryMedals)
          .map(([country, medals], index) => ({
            id: index + 1,
            country,
            gold: medals.gold,
            silver: medals.silver,
            bronze: medals.bronze,
            total: medals.gold + medals.silver + medals.bronze,
            points: medals.gold * 27 + medals.silver * 1 + medals.bronze * 1,
          }));

        const hasMedals = leaderboardData.some(item => item.total > 0);

        const sortedLeaderboard = hasMedals
          ? leaderboardData.sort((a, b) => b.points - a.points)
          : leaderboardData.sort((a, b) =>
            a.country.replace(/^[^\w\s]*/, '').localeCompare(b.country.replace(/^[^\w\s]*/, ''))
          );

        setLeaderboard(sortedLeaderboard);

        setError('');
      } catch (err) {
        console.error('Error fetching leaderboard data:', err);
        setError('Failed to load leaderboard data');
      } finally {
        setLoading(false);
      }
    };
    fetchLeaderboard();
  }, []);

  return (
    <Box sx={{ p: { xs: 1, md: 2 } }}>
      <Typography
        variant="h4"
        gutterBottom
        sx={{ color: 'white', fontWeight: 'bold', mt: 3, mx: 1 }}
      >
        <EmojiEventsIcon sx={{ fontSize: 40, marginTop: -1 }} /> Classement
      </Typography>

      <Typography variant="body2" sx={{ color: 'white', mb: 2, mx: 1 }}>
        Voici le classement pour la CJSOI 2025 aux Seychelles.
      </Typography>

      <Alert severity="info">Classement final</Alert>
      {error && (
        <Typography variant="body2" sx={{ color: 'red', mb: 2, mx: 1 }}>
          {error}
        </Typography>
      )}

      {loading ? (

        <LoadingScreen />

      ) : (
        <TableContainer
          component={Paper}
          sx={{
            backgroundColor: 'rgba(255,255,255,0.9)',
            backdropFilter: 'blur(20px)',
            borderRadius: '8px',
            overflow: 'auto',
            boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
            mt: 5
          }}
        >
          <Table>
            <TableHead sx={{ backgroundColor: 'rgb(0,127,255)', backgroundImage: 'linear-gradient(159deg, rgba(0,127,255,1) 0%, rgba(42,82,190,1) 100%)' }}>
              <TableRow sx={{ backgroundColor: 'rgba(255,255,255,0.1)' }}>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Pays</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>🥇</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>🥈</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>🥉</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {leaderboard.map((row, index) => (
                <TableRow
                  key={row.id}
                  sx={{
                    '&:hover': { backgroundColor: 'rgba(255,255,255,0.05)' },
                    transition: '0.2s ease',
                  }}
                >
                  <TableCell sx={{ color: 'black', display: 'flex', alignItems: 'center' }}>
                    {row.country}
                  </TableCell>
                  <TableCell sx={{ color: '#bb9d03' }}>{row.gold}</TableCell>
                  <TableCell sx={{ color: '#767676x`' }}>{row.silver}</TableCell>
                  <TableCell sx={{ color: '#CD7F32' }}>{row.bronze}</TableCell>
                  <TableCell sx={{ color: 'black' }}>{row.total}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default Leaderboard;